import axios from 'axios';

// Anonim guest istemcisi: interceptor YOK — 401'de /login'e yönlendirme
// public ziyaretçi sayfasında anlamsız (careerService emsali).
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5148',
  timeout: 30000,
});

export const getGuestVisit = (token) =>
  publicApi.get(`/v1/guest/visits/${encodeURIComponent(token)}`);

export const guestScan = (payload) =>
  publicApi.post('/v1/guest/scan', payload);
